<script setup lang="ts">
import ApostatudoGames from '~/components/casino/games/ApostatudoGames.vue';
</script>

<template>
  <ApostatudoGames />
</template>
